/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * LiveKit join token envelope returned to authenticated participants.
 */
export interface OralExamTokenResponse {
  token: string;
  livekitUrl: string;
  roomName: string;
  expiresAt: string;
  identity: string;
}
